<div class="time-edit-content">
  <ng-content></ng-content>
</div>
